import { render, staticRenderFns } from "./GPs.vue?vue&type=template&id=31443216"
import script from "./GPs.vue?vue&type=script&lang=js"
export * from "./GPs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports